export enum ProductType {
  LECTURE = "LECTURE",
  SUBSCRIBE = "SUBSCRIBE",
  SPECIAL_TRACK = "SPECIAL_TRACK"
}
